module.exports = __webpack_public_path__ + "docs/savings-rate-717ecb.md";